'use client'

import { useEffect, useRef } from 'react'
import useScrollProperties from '@/hooks/useScrollProperties'

type HeaderProps = {
  revealOnScroll: boolean
  leftComponent: React.ReactNode | null
  navComponent: React.ReactNode | null
  rightComponent: React.ReactNode | null
}

export default function Header({
  revealOnScroll = false,
  leftComponent,
  navComponent,
  rightComponent,
}: HeaderProps): JSX.Element {
  const headerEl = useRef(null)

  const { scrollDirection } = useScrollProperties({
    offset: 200,
    debounceDuration: 100,
  })

  // Set header height as CSS variable
  useEffect(() => {
    if (!headerEl.current || !document || !document.documentElement) {
      return
    }

    const headerHeight =
      scrollDirection === 'up' ? headerEl.current.getBoundingClientRect().height : 0

    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`)
  }, [scrollDirection])

  const scrollClass =
    revealOnScroll && scrollDirection === 'down' ? '-translate-y-[100%]' : 'translate-y-0'

  return (
    <header
      ref={headerEl}
      id="site-header"
      className={`site-header transform transition-transform duration-500 ease-in-out ${scrollClass} print:!relative print:!mb-m print:!transform-none`}>
      <div id="admin-header"></div>

      <div className="bg-theme theme--base-0">
        <div className="container container--l flex min-h-[57px] items-center justify-between gap-x-20 xl:!max-w-none xl:px-s xs:gap-x-xs">
          {leftComponent ? leftComponent : null}
          {navComponent ? navComponent : null}
          {rightComponent ? rightComponent : null}
        </div>
      </div>

      <div id="sub-header"></div>
    </header>
  )
}
